import React from 'react';
import { buildTransportTimeRangeDisplay } from './proposal/utils';

type Props = {
  departureTime: string | null;
  arrivalTime: string | null;
  departureDate: string | null;
  arrivalDate: string | null;
};

const EMPTY_LABEL = '—';

const endpointStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  lineHeight: 1.2,
  minWidth: 0
};

const timeStyles: React.CSSProperties = {
  fontSize: '14px',
  fontWeight: 700
};

const dateStyles: React.CSSProperties = {
  fontSize: '10px',
  color: '#666666',
  fontWeight: 500,
  marginBottom: '2px'
};

const arrowStyles: React.CSSProperties = {
  fontSize: '12px',
  color: '#888888',
  padding: '0 4px',
  alignSelf: 'center',
  flexShrink: 0
};

export const TransportTimeRangeCell = ({ departureTime, arrivalTime, departureDate, arrivalDate }: Props) => {
  const { departure, arrival } = buildTransportTimeRangeDisplay(
    departureTime,
    arrivalTime,
    departureDate,
    arrivalDate
  );

  if (departure == null || arrival == null) {
    if (departureTime != null && arrivalTime != null) {
      return <span>{`${departureTime} → ${arrivalTime}`}</span>;
    }
    return <span>{EMPTY_LABEL}</span>;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '2px', minWidth: 0 }}>
      <div style={endpointStyles}>
        {departure.dateLabel != null ? <span style={dateStyles}>{departure.dateLabel}</span> : null}
        <span style={timeStyles}>{departure.time}</span>
      </div>
      <span style={arrowStyles}>→</span>
      <div style={endpointStyles}>
        {arrival.dateLabel != null ? <span style={dateStyles}>{arrival.dateLabel}</span> : null}
        <span style={timeStyles}>{arrival.time}</span>
      </div>
    </div>
  );
};
